import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core'
import { UserService } from '../../modules/general/users/core/services/user.service'
import { IUser } from '../../modules/general/users/core/interfaces/IUser'
import { FunctionalType } from '../types/functional.type'
import { RolesEnum } from '../../modules/general/users/core/enums/roles.enum'
import { checkVisibleFunctional } from '../utils/check-visible-functional'
import { getPrimaryRole } from '../utils/get-primary-role'

@Directive({
	selector: '[appCheckVisibleFunctional]',
})
export class CheckVisibleFunctionalDirective implements OnInit {
	@Input('appCheckVisibleFunctional') functional: FunctionalType

	constructor(
		private _templateRef: TemplateRef<any>,
		private _viewContainerRef: ViewContainerRef,
		private _userService: UserService,
	) {}

	ngOnInit(): void {
		const userDetail: IUser | null = this._userService.userDetail$.getValue()
		const role: RolesEnum | undefined = getPrimaryRole(userDetail?.roles)

		if (checkVisibleFunctional(this.functional, role)) {
			this._viewContainerRef.createEmbeddedView(this._templateRef)
		} else {
			this._viewContainerRef.clear()
		}
	}
}